export const environment = {
    production: true,
    rootPath: '/api',
    domainPrefix: '',
    copyright: '© $YEAR$ Mafin Group',
    address: '',
    forbiddenWords: ['admin', 'default', 'member', 'root', 'test', 'user']
};
